import { defineAction } from "redux-define";
export const PRIVATE_ROUTE = defineAction("PRIVATE_ROUTE", [
  "SAVE_LOGIN_URL",
  "DISCARD_LOGIN_URL"
]);
